import React from "react";
import HeartSvg from "../../components/svgs/HeartSvg";
import "./SingleCat.css";

interface SingleCatProps {
  image: string;
  name: string;
  price: number;
  stock: number;
}

const SingleCatCard: React.FC<SingleCatProps> = ({
  image,
  name,
  price,
  stock,
}) => {
  return (
    <div className="single-cat-card">
      <div className="single-cat-card__image-container">
        <img src={image} alt={name} className="single-cat-card__image" />
        <button className="single-cat-card__wishlist">
          <HeartSvg />
        </button>
      </div>
      <div className="single-cat-card__info">
        <h3 className="single-cat-card__name">{name}</h3>
        <p className="single-cat-card__price">
          <strong>${price.toFixed(2)}</strong> Per Unit
        </p>
        <p className="single-cat-card__stock">{stock} units left</p>
      </div>
    </div>
  );
};

export default SingleCatCard;
